import * as React from "react"
import { ModalComponent } from "./ModalComponent";
import ForceCloseConsultation from "../containers/Ongoing/ForceCloseConsultation";
import { ForceCloseReason } from "../utils/AppConstants";
import LocalStorageUtils from "../utils/LocalStorageUtils";
import { EventNames } from "../utils/EventTrackerConstants";
import AppUtils from "../utils/AppUtils";

/**
 * Created by aditya on 06/02/18.
 */

export interface ForceCloseConsultationWrapperProps {
    consultationMode: string;
    forceCompleteAppointment: (status: string, reasonCode: ForceCloseReason, reasonText: string) => void;
    shouldShowforceCloseModal: boolean
    toggleForceCloseModal(): void;
}



class ForceCloseConsultationWrapper extends React.Component<ForceCloseConsultationWrapperProps, null> {
    constructor(props: ForceCloseConsultationWrapperProps) {
        super(props);
    }

    render() {
        const { consultationMode, shouldShowforceCloseModal } = this.props;
        return (
            <div onClick={this.props.toggleForceCloseModal} className="force-close-consultation-wrapper">
                {!AppUtils.getIsMobile() && (
                    <img className="force-close-icon" src="/images/icons/grey-cancel.png" />
                )}
                <span>Exit Consultation (Force Close)</span>
                {
                    shouldShowforceCloseModal &&
                    <ModalComponent modalSize={"small"} keepPadding={false} onClickCloseHandler={this.props.toggleForceCloseModal}>
                        <ForceCloseConsultation forceCompleteAppointment={this.props.forceCompleteAppointment} consultationMode={consultationMode}
                            toggleForceCloseModal={this.props.toggleForceCloseModal} />
                    </ModalComponent>
                }
            </div>
        )
    }
}

export default ForceCloseConsultationWrapper;